import checkDocument from 'utils/checkDocument';
import checkInputs from 'utils/checkInputs';

const validations = {
    editProvider: function validationEditUser(updatedProvider) {
        const errors = {};

        if (!checkInputs.notNull(updatedProvider.nombres)) {
            errors.nombres = "Es necesario.";
        } else if (!checkInputs.isAlphanumeric(updatedProvider.nombres)) {
            errors.nombres = "No ingrese caracteres especiales.";
        } else if (updatedProvider.nombres.length > 300) {
            errors.nombres = 'No ingrese más de 300 caracteres.';
        }

        if (checkInputs.notNull(updatedProvider.direccion = "")) {
            if (!checkInputs.isAlphanumeric(updatedProvider.direccion)) {
                errors.direccion = "Solo ingrese: letras, números, '#', '.' o paréntesis";
            } else if (updatedProvider.direccion.length > 300) {
                errors.direccion = 'No ingrese más de 300 caracteres.';
            }
        }

        if (!checkInputs.notNull(updatedProvider.correo)) {
            errors.correo = 'El correo es necesario.'
        } else if (!checkInputs.validationEmail(updatedProvider.correo)) {
            errors.correo = 'El correo es incorrecto. Debe contener el usuario, @ y el dominio.'
        } else if (updatedProvider.correo.length > 300) {
            errors.correo = 'No ingrese más de 300 caracteres.';
        }

        let regex = new RegExp("[0-9]{3,4}-[0-9]{4}");
        if (checkInputs.notNull(updatedProvider.telefono)) {
            if (!checkInputs.isAlphanumeric(updatedProvider.telefono)) {
                errors.telefono = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
            } else if (updatedProvider.telefono.length > 12 || updatedProvider.telefono.length < 7) {
                errors.telefono = 'No ingrese entre 7 y 12 caracteres.';
            } else if (!regex.test(updatedProvider.telefono)) {
                errors.telefono = 'El formato del teléfono no es correcto.';
            }
        }

        return errors;
    },
    addProvider: function validationAddProvider(newProvider) {
        const errors = {};
        //Validaciones si el tipo de receptor es 01 contribuyente o 03 gobierno
        if (newProvider.tipoReceptor === "01" || newProvider.tipoReceptor === "03") {
            if (!checkInputs.notNull(newProvider.idCliente)) {
                errors.idCliente = "Ingrese la identificación del usuario.";
            } else if (!checkInputs.isAlphanumeric(newProvider.idCliente)) {
                errors.idCliente =
                    "No puede contener caracteres especiales, solo letras o números.";
            } else if (newProvider.idCliente.length > 300) {
                errors.idCliente = "No ingrese más de 300 caracteres.";
            }

            if (!checkInputs.notNull(newProvider.direccion)) {
                errors.direccion = "Ingrese la dirección es necesario si el cliente es contribuyente.";
            } else if (!checkInputs.isAlphanumeric(newProvider.direccion)) {
                errors.direccion = "No ingrese caracteres especiales.";
            } else if (newProvider.direccion.length > 300) {
                errors.direccion = "No ingrese más de 300 caracteres.";
            }

            if (!checkInputs.notNull(newProvider.nombres)) {
                errors.nombres = "El nombre o la razón social es necesario.";
            } else if (!checkInputs.isAlphanumeric(newProvider.nombres)) {
                errors.nombres = "Ingrese caracteres alfanuméricos.";
            } else if (newProvider.nombres.length > 300) {
                errors.nombres = "No ingrese más de 300 caracteres.";
            }

            if (!checkInputs.notNull(newProvider.digitoVerificador)) {
                errors.digitoVerificador = "El dígito verificador es necesario.";
            } else if (newProvider.digitoVerificador.length !== 2) {
                errors.digitoVerificador = "Ingrese dos caracteres del dígito verificador, por ejemplo 01.";
            }

            if (!checkInputs.notNull(newProvider.tipoContribuyente)) {
                errors.tipoContribuyente = "El tipo de contribuyente es necesario.";
            }

            if (!checkInputs.notNull(newProvider.paisReceptor)) {
                errors.paisReceptor = "El país receptor es necesario.";
            } else if (newProvider.paisReceptor !== "PA") {
                errors.paisReceptor = "El país receptor debe ser Panamá";
            }

            if (checkInputs.notNull(newProvider.paisExtranjero)) {
                errors.paisExtranjero = "No ingresar el país extranjero, el cliente es contribuyente o de gobierno."
            }

            if (checkInputs.notNull(newProvider.paisReceptorDesc)) {
                errors.paisReceptorDesc = "No ingresar el nombre del país extranjero, el cliente es contribuyente o de gobierno."
            }

            if (!checkInputs.notNull(newProvider.ubicacionGeografica)) {
                errors.ubicacionGeografica = "La ubicación geográfica es necesaria."
            }
        }

        //Validaciones si el tipo de receptor es 04 extranjero
        if (newProvider.tipoReceptor === "04") {

            if (!checkInputs.notNull(newProvider.idCliente)) {
                errors.idCliente = "Ingrese la identificación del usuario.";
            } else if (newProvider.typeDocument === "C") {
                if (
                    // !checkDocument.validarCedula(newProvider.idCliente) &&
                    // !checkDocument.validarRucPersonaNatural(
                    //   newProvider.idCliente
                    // ) &&
                    // !checkDocument.validarRucSociedadPrivada(
                    //   newProvider.idCliente
                    // ) &&
                    // !checkDocument.validarRucSociedadPublica(
                    //   newProvider.idCliente
                    //)
                    false
                ) {
                    errors.idCliente = "Cédula o RUC inválido.";
                }
            } else if (!checkInputs.isAlphanumeric(newProvider.idCliente)) {
                errors.idCliente =
                    "No puede contener caracteres especiales, solo letras o números.";
            } else if (newProvider.idCliente.length > 300) {
                errors.idCliente = "No ingrese más de 300 caracteres.";
            }

            if (checkInputs.notNull(newProvider.digitoVerificador)) {
                errors.digitoVerificador = "No ingresar el dígito verificador, el cliente es extranjero.";
            }

            if (checkInputs.notNull(newProvider.tipoContribuyente)) {
                errors.tipoContribuyente = "No ingresar el tipo de contribuyente, el cliente es extranjero."
            }

            if (!checkInputs.notNull(newProvider.paisReceptor)) {
                errors.paisReceptor = "El país receptor es necesario.";
            } else if (newProvider.paisReceptor === "PA") {
                errors.paisReceptor = "El país receptor no debe ser Panamá, el cliente es extranjero.";
            }

            if (checkInputs.notNull(newProvider.paisExtranjero)) {
                if (!checkInputs.isAlphanumeric(newProvider.paisExtranjero)) {
                    errors.paisExtranjero = "Ingrese caracteres alfanuméricos.";
                } else if (newProvider.paisExtranjero.length > 100) {
                    errors.paisExtranjero = "No ingrese más de 100 caracteres.";
                }
            }

            if (!checkInputs.notNull(newProvider.nombres)) {
                errors.nombres = "El nombre del cliente es necesario.";
            } else if (!checkInputs.isAlphanumeric(newProvider.nombres)) {
                errors.nombres = "Ingrese caracteres alfanuméricos.";
            } else if (newProvider.nombres.length > 300) {
                errors.nombres = "No ingrese más de 300 caracteres.";
            }

            if (checkInputs.notNull(newProvider.direccion)) {
                if (!checkInputs.isAlphanumeric(newProvider.direccion)) {
                    errors.direccion = "No ingrese caracteres especiales.";
                } else if (newProvider.direccion.length > 300) {
                    errors.direccion = "No ingrese más de 300 caracteres.";
                }
            }

            if (newProvider.paisReceptor === "ZZZ" && !checkInputs.notNull(newProvider.paisReceptorDesc)) {
                errors.paisReceptorDesc = "El nombre del país es necesario."
            }

            if (checkInputs.notNull(newProvider.ubicacionGeografica)) {
                errors.ubicacionGeografica = "No ingresar la ubicación geográfica, el cliente es extranjero."
            }

        }

        //Validaciones opcionales para todo cliente
        if (checkInputs.notNull(newProvider.sucursal)) {
            if (newProvider.sucursal.length > 4) {
                errors.sucursal = "No ingrese más de 4 caracteres.";
            }
        }

        let regexCoordenadas = new RegExp("[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}[,]{1}[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}");
        if (checkInputs.notNull(newProvider.coordenadasSucursal)) {
            if (newProvider.coordenadasSucursal.length > 22) {
                errors.coordenadasSucursal = "No ingrese más de 22 caracteres.";
            } else if (!regexCoordenadas.test(newProvider.coordenadasSucursal)) {
                errors.coordenadasSucursal = 'El formato de la coordenada de la sucursal no es correcto.';
            }
        }

        let regex = new RegExp("[0-9]{3,4}-[0-9]{4}");
        if (checkInputs.notNull(newProvider.telefono)) {
            if (!checkInputs.isAlphanumeric(newProvider.telefono)) {
                errors.telefono = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
            } else if (newProvider.telefono.length > 12 || newProvider.telefono.length < 7) {
                errors.telefono = 'No ingrese entre 7 y 12 caracteres.';
            } else if (!regex.test(newProvider.telefono)) {
                errors.telefono = 'El formato del teléfono no es correcto.';
            }
        }

        //Validaciones obligatorias para todo cliente
        if (!checkInputs.notNull(newProvider.correoCliente)) {
            errors.correoCliente = "El correo del usuario es necesario.";
        } else if (!checkInputs.validationEmail(newProvider.correoCliente)) {
            errors.correoCliente =
                "El correo del usuario es erroneo. Ingrese un correo con el formato user@ejemplo.com";
        } else if (newProvider.correoCliente.length > 300) {
            errors.correoCliente = "No ingrese más de 300 caracteres.";
        }


        return errors;
    },
}

export default validations;